import React from 'react';
import { BrowserRouter } from 'react-router-dom';

// auth provider
import { JWTProvider as AuthProvider } from './contexts/JWTContext';
import { NotificationProvider } from './contexts/NotificationContext';
import CustomToast from './common/CustomToast';

import routes, { renderRoutes } from './routes';

const App = () => {
  return (
    <React.Fragment>
      <NotificationProvider>
        <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
          <AuthProvider>{renderRoutes(routes)}</AuthProvider>
        </BrowserRouter>
        {/* Triggering HMR */}
        <CustomToast />
      </NotificationProvider>
    </React.Fragment>
  );
};

export default App;
